import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveSvg from '../ResponsiveSvg';
import { ssColorCyan, ssColorBlack } from '../../constants/style-constants';

const CompleteIcon = ({ tickColor, backgroundColor }) => (
  <ResponsiveSvg>
    <svg version="1.1" viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg">
      <path
        css={{
          fill: backgroundColor,
        }}
        d="m640 320c0 176.61-143.39 320-320 320s-320-143.39-320-320 143.39-320 320-320 320 143.39 320 320z"
      />
      <path
        css={{
          fill: tickColor,
        }}
        d="m338.32 434.65 0.02 0.01-83.92 81.85-155.45-151.61 83.92-81.85 71.51 69.74 213.33-208.06 83.92 81.85-213.33 208.07z"
      />
    </svg>
  </ResponsiveSvg>
);

CompleteIcon.defaultProps = {
  tickColor: ssColorBlack,
  backgroundColor: ssColorCyan,
};

CompleteIcon.propTypes = {
  tickColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default CompleteIcon;
